<template>
  <v-form
      class="contact-card__input"
      ref="form_contact"
      v-model="valid"
      lazy-validation
  >
    <v-row class="info-card" dense no-gutters>
    <v-col
        :cols="row.cols ? row.cols : 12"
        class="info-card__field"
        :class="{'pr-3': row.cols && row.cols !== 12 && (i +1) !== config.length}"
        v-for="(row, i) in config"
        :key="i
">
      <div class="info-card__name">
        {{ row.name }}
      </div>
      <v-text-field
          v-if="row.type === 'input' && !(row.dataField === 'confirmPassword' || row.dataField === 'password')"
          v-model="form[row.dataField]"
          :disabled="row.disabled"
          :rules="row.rules ? [...row.rules] : [rules.required]"
          :type="row.typeInput ? row.typeInput : 'text'"
          color="#00599B"
          outlined
          class="info-card__cell"
          dense
      />
      <VuePhoneNumberInput
          v-else-if="row.type === 'telephone'"
          class=""
          v-model="form[row.dataField]"
          :only-countries="['RU']"
          default-country-code="RU"
          valid-color="#263238"
          error-color="#C00000"
          :error="errorNumber"
          color="#546e7a"
          @update="updatePhoneValue($event, row.dataField,row.dataField, row.dataField + 'Formatted')"
          :translations="translations1"
      />
      <v-autocomplete
          v-else-if="row.type === 'selector'"
          v-model="form[row.dataField]"
          :items="sprData[row.sprDataName].data"
          :loading="sprData[row.sprDataName].loading"
          :rules="row.rules ? row.rules : [rules.required]"
          no-data-text="По вашему запросу ничего нет"
          :disabled="row.disabled"
          dense
          class="info-card__cell"
          clearable
          outlined
      />
    </v-col>
    </v-row>
  </v-form>

</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input/dist/vue-phone-number-input.common';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
export default {
  name: "CardInput",
  components: {
    VuePhoneNumberInput,
  },
  props: {
    value: {
      type: Object,
    },
    sprData:{
      type: Object,
      default: () => {return {}}
    },
    savingData:{
      type: Boolean,
      default: false
    },
    config:{
      type: Array,
      default: () => {
        return []
      }
    },
    canCloseEnter:{
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      valid: true,
      isOnButtonSave: false,
      errorNumber: false,
      translations1:{
        countrySelectorLabel: 'Код страны',
        countrySelectorError: 'Неверный код страны',
        phoneNumberLabel: '',
        example: 'Пример :'
      },
      form: {...this.value},
      rules: {
        required: value => !!value || 'Обязательное поле!',
        counter: value => value.length > 10 || 'Поле не может содержать меньше 10 символов',
        counter3: value => value.length >= 3 || 'Поле не может содержать меньше 3 символов',
        dolg: value => value.length >= 5 || 'Поле не может содержать меньше 5 символов',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Неверно указан адрес почты'
        },
      },
    }
  },
  created(){
   /*this.initForm();*/
  },
  methods: {
    initForm(){
      const obj = {};
      for (const [ key, value] of Object.entries(this.value)){
        obj[key] = (typeof value === 'object') ? value?.id ?? value : value
      }
      return obj
    },
    inputPhone(str,  variable){
      if (!str)
        this.form[variable] = ''
    },
    updatePhoneValue(obj, validateVariable, variable, formattedVariable){
      this.form[variable] = obj.e164;
      this.form[formattedVariable] = obj.e164;
      this.errorNumber = !obj.isValid
    },
    async validate() {
      this.valid = this.$refs.form_contact.validate()
    },
    async sendData(){
      await this.validate();
      if (this.valid) {
        this.$emit('input', {
          ...this.value,
          ...this.form,
          workPhoneNumber: this.form.workPhoneNumberFormatted,
          personalPhoneNumber: this.form.personalPhoneNumberFormatted
        })
      }
      else
        console.log("не все данные заполнены")
    },
    onChange() {
      this.isOnButtonSave = true;
    },
    cancel() {
      this.$emit('cancel');
    }
  }

}
</script>

<style lang="sass" >
.contacts-autocomplete
  &.theme--light.v-text-field--filled
    >.v-input__control
     > .v-input__slot
        background-color: #E3EFFA
.contact-card__input
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus
    -webkit-text-fill-color: #455058
    -webkit-box-shadow: 0 0 0px 1000px #E3EFFA inset
  .input-country-selector
    input
      background-color: #E3EFFA!important
      color: #455058
  .input-phone-number
    //.input-tel__label
    input
      background-color: #E3EFFA!important
      color: #455058
  .info-card__name
    color: #455058
    font-size: 16px
    //margin-right: 21px
    padding-bottom: 6px
    white-space: nowrap
    line-height: 18.75px
    font-weight: 400
  .info-card__cell
    &.v-text-field--outlined fieldset :not(.error--text)
      //&:not(.error--text)
      border-color: #78909C
      border-radius: 7px
      max-height: 36px
    //&.error--text
    //  .v-text-field--outlined //fieldset
    //    border-color: #ED393E

    .v-input__slot
      min-height: 20px!important
      max-height: 36px!important
      background-color: #E3EFFA
    .v-text-field__details
      margin-bottom: 0
    .v-text-field__slot
      height: 36px
      input
        color: #455058!important

  .info-card__field
    display: flex
    flex-direction: column
    //align-items: flex-start
    //justify-content: center
  .info-card__button
    margin-top: 10px
    margin-left: 10px
</style>